import { Link, useNavigate } from "react-router-dom";
import MaxiPitchImage from "/images/maxipitch.png";
import neslogo from "../../assets/images/nselogo.jpg";
export default function Footer() {
  const navigate = useNavigate();

  const handlePricingClick = () => {
    const token = localStorage.getItem("token");

    if (token) {
      navigate("/pricing");
    } else {
      navigate("/pricing-plans");
    }
  };
  return (
    <footer className="bg-white border-t border-gray-200 py-6 relative z-10 max-md:px-2 pt-10 ">
      <div className="container mx-auto px-4 max-md:px-1">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          <div className="space-y-1">
            <img
              src={MaxiPitchImage}
              alt="MaxiPitch"
              className="h-7 max-md:h-7  cursor-pointer"
              onClick={() => navigate("/")}
            />
            <p className="text-base max-md:text-[14px] pt-2 font-semibold text-black/80 pl-1">
              Digikore Studios Limited, <br /> Lalwani Triumph, Viman Nagar,
              Pune, MH 411014
            </p>
          </div>
          <div>
            <h3 className="font-semibold text-lg max-md:text-xl mb-0 text-gray-900 max-md:pl-1 max-md:pt-1">
              Listed on NSE
            </h3>
            <img
              src={neslogo}
              alt="MaxiPitch"
              className="h-10 cursor-pointer mt-2"
              onClick={() => navigate("/")}
            />
          </div>

          <div>
            <h3 className="font-semibold text-lg max-md:text-md mb-3 text-gray-900">
              Product
            </h3>

            <ul className="space-y-2 text-sm mb-2">
              <li>
                <button
                  onClick={handlePricingClick}
                  className="text-gray-600 hover:text-blue-600"
                >
                  Pricing
                </button>
              </li>
            </ul>
            <ul className="space-y-2 text-sm">
              <li>
                <button
                  onClick={() => navigate("/how-to-use")}
                  className="text-gray-600 hover:text-blue-600"
                >
                  How To Use
                </button>
              </li>

              <li>
                <Link
                  to="/maxipitch-benefits"
                  className="text-gray-600 hover:text-blue-600"
                >
                  MaxiPitch Benefits
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-600 hover:text-blue-600">
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-lg max-md:text-md mb-3 text-gray-900">
              Support
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  to="/about-us"
                  className="text-gray-600 hover:text-blue-600 "
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/contact-us"
                  className="text-gray-600 hover:text-blue-600 "
                >
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-600 hover:text-blue-600">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-lg max-md:text-md mb-3 text-gray-900">
              Legal
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  to="/privacy-policy"
                  className="text-gray-600 hover:text-blue-600 "
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms-and-Conditions"
                  className="text-gray-600 hover:text-blue-600 "
                >
                  Terms Of Service
                </Link>
              </li>
              <li>
                <Link
                  to="/cancellation-and-refund"
                  className="text-gray-600 hover:text-blue-600 "
                >
                  Cancellation And Refund
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-4 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center text-xs text-gray-600">
          <p className="text-center md:text-left">
            &copy; {new Date().getFullYear()} Maxipitch. All rights reserved
          </p>
          <p className="text-center md:text-right mt-2 md:mt-0">
            MaxiPitch - Get new customers every day, automatically.
          </p>
          {/* <div className="flex space-x-4 mt-4 md:mt-0">
            <Link to="#" className="hover:text-blue-600 ">
              Twitter
            </Link>
            <Link to="#" className="hover:text-blue-600 ">
              LinkedIn
            </Link>
            <Link to="#" className="hover:text-blue-600 ">
              Facebook
            </Link>
          </div> */}
        </div>
      </div>
    </footer>
  );
}
